import { fetchJSON } from '@runtime/shared/api/fetchJSON'

type PosterThemeAccessResponse = {
  ok: true
  themeId: string
  accessToken: string | null
}

type RequestPosterThemeAccessArgs = {
  themeId: string
  password?: string
  publicSlug?: string
  authToken?: string | null
}

export async function requestPosterThemeAccess({
  themeId,
  password,
  publicSlug,
  authToken,
}: RequestPosterThemeAccessArgs): Promise<string | null> {
  const payload = {
    ...(password ? { password } : {}),
    ...(publicSlug ? { publicSlug } : {}),
  }
  const response = await fetchJSON<PosterThemeAccessResponse>(
    `/api/poster-themes/${encodeURIComponent(themeId)}/access`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
      },
      body: JSON.stringify(payload),
    },
  )

  return response.accessToken || null
}
